import { Seo } from "@/components/Seo";
import { PageHead, Section } from "@/components/Shared";
import { UI } from "@/i18n/ui";
import { SITE, PLACEHOLDER } from "@/data/site";

const LEGAL = {
  privacy: {
    id: {
      title: "Kebijakan Privasi",
      body: [
        ["Kerahasiaan Anda", "Bali Empower menjaga kerahasiaan seluruh informasi klien sesuai etika profesi psikologi dan peraturan yang berlaku di Indonesia. Informasi pribadi dan isi sesi konsultasi tidak dibagikan kepada pihak lain tanpa persetujuan Anda, kecuali diwajibkan oleh hukum atau menyangkut keselamatan."],
        ["Data yang Kami Kumpulkan", "Melalui website ini kami mengumpulkan data yang Anda kirimkan secara sukarela melalui formulir booking dan kontak: nama, nomor telepon/WhatsApp, email (opsional), dan pesan Anda. Data digunakan hanya untuk menindaklanjuti permintaan Anda."],
        ["Penyimpanan & Keamanan", `Detail kebijakan penyimpanan dan keamanan data akan dilengkapi. ${PLACEHOLDER.id}`],
        ["Hubungi Kami", `Untuk pertanyaan tentang privasi, hubungi kami melalui WhatsApp di ${SITE.phone}.`],
      ],
    },
    en: {
      title: "Privacy Policy",
      body: [
        ["Your Confidentiality", "Bali Empower protects all client information in accordance with professional psychology ethics and applicable Indonesian regulations. Personal information and session content are not shared without your consent, except where legally required or where safety is at risk."],
        ["Data We Collect", "Through this website we collect data you voluntarily submit via the booking and contact forms: name, phone/WhatsApp number, email (optional) and your message. Data is used solely to follow up on your request."],
        ["Storage & Security", `Detailed data storage and security policies will be completed. ${PLACEHOLDER.en}`],
        ["Contact Us", `For privacy questions, contact us via WhatsApp at ${SITE.phone}.`],
      ],
    },
  },
  terms: {
    id: {
      title: "Syarat & Ketentuan",
      body: [
        ["Layanan", "Website ini menyediakan informasi tentang layanan psikologi Bali Empower dan sarana untuk membuat janji konsultasi. Konten edukatif di website ini bukan pengganti konsultasi klinis individual."],
        ["Janji Konsultasi", "Permintaan booking melalui website akan dikonfirmasi oleh tim kami melalui WhatsApp. Jadwal final bergantung pada ketersediaan."],
        ["Ketentuan Lengkap", `Syarat dan ketentuan lengkap akan dilengkapi. ${PLACEHOLDER.id}`],
      ],
    },
    en: {
      title: "Terms & Conditions",
      body: [
        ["Services", "This website provides information about Bali Empower's psychology services and a means to book consultations. Educational content on this website is not a substitute for individual clinical consultation."],
        ["Appointments", "Booking requests via the website will be confirmed by our team via WhatsApp. The final schedule depends on availability."],
        ["Full Terms", `Complete terms and conditions will be finalized. ${PLACEHOLDER.en}`],
      ],
    },
  },
  cancellation: {
    id: {
      title: "Kebijakan Pembatalan",
      body: [
        ["Keterlambatan", "Keterlambatan akan mengurangi durasi sesi Anda. Batas maksimal keterlambatan adalah 15 menit dari jadwal yang telah ditentukan. Keterlambatan dari jadwal yang telah disepakati dapat dikenakan biaya tambahan sebesar Rp50.000 (maksimal 30 menit)."],
        ["Pembatalan & Perubahan Jadwal", "Informasikan pembatalan atau perubahan jadwal maksimal 3 jam sebelum sesi dimulai. Informasi tepat waktu dari Anda sangat membantu efektivitas kerja psikolog serta pelayanan klien lain."],
        ["Ketidakhadiran Tanpa Konfirmasi (No-Show)", "Apabila klien tidak hadir tanpa konfirmasi sementara psikolog telah hadir dan menunggu sesuai jadwal, maka sesi dianggap terpakai dan klien dipersilakan melakukan penjadwalan ulang tanpa biaya tambahan."],
        ["Konfirmasi Kehadiran & Pembayaran Dimuka", `Tersedia opsi pembayaran dimuka (DP atau lunas) sebagai bentuk komitmen reservasi. Pembayaran dimuka tidak dapat dikembalikan apabila klien membatalkan secara sepihak kurang dari 3 jam sebelum sesi. Hubungi admin di WhatsApp ${SITE.phone} untuk informasi metode pembayaran.`],
        ["Catatan Jadwal", "Jadwal konseling yang telah disepakati bersifat tentatif dan akan disesuaikan dengan antrian yang berlaku."],
      ],
    },
    en: {
      title: "Cancellation Policy",
      body: [
        ["Late Arrival", "Late arrival reduces your session duration. The maximum lateness allowed is 15 minutes from the scheduled time. Lateness beyond the agreed schedule may incur an additional fee of Rp50,000 (maximum 30 minutes)."],
        ["Cancellation & Rescheduling", "Please inform us of any cancellation or schedule change at least 3 hours before the session starts. Timely notice helps the psychologist work effectively and serves other clients fairly."],
        ["No-Show Without Confirmation", "If a client does not attend without confirmation while the psychologist has arrived and waited as scheduled, the session is considered used and the client may reschedule without an additional fee."],
        ["Attendance Confirmation & Advance Payment", `An advance payment option (deposit or full) is available as a reservation commitment. Advance payments are non-refundable if the client cancels unilaterally less than 3 hours before the session. Contact our admin on WhatsApp at ${SITE.phone} for payment methods.`],
        ["Scheduling Note", "Agreed counseling schedules are tentative and adjusted according to the applicable queue."],
      ],
    },
  },
};

export default function Legal({ lang, kind }) {
  const t = UI[lang];
  const c = LEGAL[kind][lang];
  const metaDesc = {
    id: `${c.title} Bali Empower — klinik psikologi di Renon, Denpasar Selatan, Bali.`,
    en: `Bali Empower ${c.title} — psychology clinic in Renon, Denpasar Selatan, Bali.`,
  }[lang];
  return (
    <div data-testid={`legal-page-${kind}`}>
      <Seo title={`${c.title} | Bali Empower`} description={metaDesc} lang={lang} />
      <PageHead eyebrow={t.footer.legal} title={c.title} />
      <Section className="pt-0">
        <div className="max-w-3xl space-y-8">
          {c.body.map(([h, p]) => (
            <div key={h}>
              <h2 className="text-xl font-display text-[#1F2937] mb-2">{h}</h2>
              <p className="text-[#4B5563] leading-relaxed text-[15px]">{p}</p>
            </div>
          ))}
        </div>
      </Section>
    </div>
  );
}
